import {DataProvider, fetchUtils} from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';
import {BASE_URL} from "../constants/api-url";

export  interface ExtendedDataProvider extends DataProvider {
  customMethod: (url: string, options?: any) => Promise<any>;
}

const baseUrl = BASE_URL;

const httpClient = (url: string, options: fetchUtils.Options = {}) => {
  const opts = {
    ...options,
    headers: new Headers(options.headers || {}),
  };
  const token = localStorage.getItem('admin_token');
  if (token) {
    (opts.headers as Headers).set('Authorization', `Bearer ${token}`);
  }
  return fetchUtils.fetchJson(url, opts);
};

const baseProvider: DataProvider = simpleRestProvider(baseUrl, httpClient);

export const dataProvider: ExtendedDataProvider = {
  ...baseProvider,

  customMethod: async (url: string, options: any = {}) => {
    const requestUrl = `${baseUrl}${url}`;
    const { json } = await httpClient(requestUrl, options);
    return { data: json };
  },
};

